import React, { useEffect, useState } from 'react'
import Footer from './Footer'
import video_player from '../images/video-player.svg'
import NumberFormat from 'react-number-format';
import '../components_css/Worksheet.css'
import { useHistory } from 'react-router'
import Modal from 'react-modal';
import zIndex from '@material-ui/core/styles/zIndex'
import * as allCurrency from '../constant/CURRENCY';
import {floatCheck, momentConvertFormat, CustomInput} from '../utils/globalFunction'
import { Autosave } from 'react-autosave'; 

function Worksheet5({ Q26, Q27, Q34, Q48, Q52, setQ52, WorksheetYear, setWorksheetYear,backCall,submitCall,saveCall, mainData }) {
    const [currency, setCurrency] = useState(allCurrency.CURRENCY.find(item=>item.id===parseInt(mainData?.client_information?.currency))?.symbol || '$')
    const [crun, setCrun] = useState('1')
    const [Q53, setQ53] = useState(floatCheck(mainData?.worksheet?.advertising_marketing))
    const [Q54, setQ54] = useState(floatCheck(mainData?.worksheet?.asset_purchase))
    const [Q55, setQ55] = useState(floatCheck(mainData?.worksheet?.bank_service_charge))
    const [Q56, setQ56] = useState(floatCheck(mainData?.worksheet?.bank_insurance))
    const [Q57, setQ57] = useState(floatCheck(mainData?.worksheet?.charitable_contribution))
    const [Q58, setQ58] = useState(floatCheck(mainData?.worksheet?.company_contribution_retirement_staff))
    const [Q59, setQ59] = useState(floatCheck(mainData?.worksheet?.continuing_education))
    const [Q60, setQ60] = useState(floatCheck(mainData?.worksheet?.entertainment))
    const [Q61, setQ61] = useState(floatCheck(mainData?.worksheet?.business_personal_property_tax))
    const [Q62, setQ62] = useState(floatCheck(mainData?.worksheet?.gift))
    const [Q63, setQ63] = useState(floatCheck(mainData?.worksheet?.health_insurance_staff))
    const [Q64, setQ64] = useState(floatCheck(mainData?.worksheet?.interest_expenses))
    const [Q65, setQ65] = useState(floatCheck(mainData?.worksheet?.loan_payment_balance_sheet))
    const [Q66, setQ66] = useState(floatCheck(mainData?.worksheet?.meals))
    const [Q67, setQ67] = useState(floatCheck(mainData?.worksheet?.merchant_service_fees))
    const [Q68, setQ68] = useState(floatCheck(mainData?.worksheet?.office_phone))
    const [Q69, setQ69] = useState(floatCheck(mainData?.worksheet?.office_rent))
    const [Q70, setQ70] = useState(floatCheck(mainData?.worksheet?.office_repair_maintenance))
    const [Q71, setQ71] = useState(floatCheck(mainData?.worksheet?.office_supplies))
    const [Q72, setQ72] = useState(floatCheck(mainData?.worksheet?.office_utilities))
    const [Q73, setQ73] = useState(floatCheck(mainData?.worksheet?.other_contract_expenses))
    const [Q74, setQ74] = useState(floatCheck(mainData?.worksheet?.postage_and_delivery))
    const [Q75, setQ75] = useState(floatCheck(mainData?.worksheet?.professional_fees))
    const [Q76, setQ76] = useState(floatCheck(mainData?.worksheet?.telephone))
    const [Q77, setQ77] = useState(floatCheck(mainData?.worksheet?.total_wages_from_payroll))
    const [Q78, setQ78] = useState(floatCheck(mainData?.worksheet?.workers_compensation_insurance))
    const [Q79, setQ79] = useState(floatCheck(mainData?.worksheet?.other_operating_expenses))
    const [expensesWriteHere, setExpensesWriteHere] = useState(mainData?.worksheet?.expenses_write_here || '')

    const [ShowPopup, setShowPopup] = useState(false)
    const [Analyze, setAnalyze] = useState('')
    
    useEffect(() => {
        window.scrollTo(0, 0);
    },[])

    useEffect(()=>{
        setCrun(mainData?.client_information?.currency)
    },[mainData])

    useEffect(() => {
        console.log(Q53)
        setQ52((parseFloat((typeof Q53==='undefined' || Q53==='' || Number.isNaN(Q53))? 0 : Q53) + parseFloat((typeof Q54==='undefined' || Q54==='' || Number.isNaN(Q54))? 0 : Q54) + parseFloat((typeof Q55==='undefined' || Q55==='' || Number.isNaN(Q55))? 0 : Q55) + parseFloat((typeof Q56==='undefined' || Q56==='' || Number.isNaN(Q56))? 0 : Q56) + parseFloat((typeof Q57==='undefined' || Q57==='' || Number.isNaN(Q57))? 0 : Q57) + parseFloat((typeof Q58==='undefined' || Q58==='' || Number.isNaN(Q58))? 0 : Q58) + parseFloat((typeof Q59==='undefined' || Q59==='' || Number.isNaN(Q59))? 0 : Q59) + parseFloat((typeof Q60==='undefined' || Q60==='' || Number.isNaN(Q60))? 0 : Q60) + parseFloat((typeof Q61==='undefined' || Q61==='' || Number.isNaN(Q61))? 0 : Q61) + parseFloat((typeof Q62==='undefined' || Q62==='' || Number.isNaN(Q62))? 0 : Q62) + parseFloat((typeof Q63==='undefined' || Q63==='' || Number.isNaN(Q63))? 0 : Q63) + parseFloat((typeof Q64==='undefined' || Q64==='' || Number.isNaN(Q64))? 0 : Q64) + parseFloat((typeof Q65==='undefined' || Q65==='' || Number.isNaN(Q65))? 0 : Q65) + parseFloat((typeof Q66==='undefined' || Q66==='' || Number.isNaN(Q66))? 0 : Q66) + parseFloat((typeof Q67==='undefined' || Q67==='' || Number.isNaN(Q67))? 0 : Q67) + parseFloat((typeof Q68==='undefined' || Q68==='' || Number.isNaN(Q68))? 0 : Q68) + parseFloat((typeof Q69==='undefined' || Q69==='' || Number.isNaN(Q69))? 0 : Q69) + parseFloat((typeof Q70==='undefined' || Q70==='' || Number.isNaN(Q70))? 0 : Q70) + parseFloat((typeof Q71==='undefined' || Q71==='' || Number.isNaN(Q71))? 0 : Q71) + parseFloat((typeof Q72==='undefined' || Q72==='' || Number.isNaN(Q72))? 0 : Q72) + parseFloat((typeof Q73==='undefined' || Q73==='' || Number.isNaN(Q73))? 0 : Q73) + parseFloat((typeof Q74==='undefined' || Q74==='' || Number.isNaN(Q74))? 0 : Q74) + parseFloat((typeof Q75==='undefined' || Q75==='' || Number.isNaN(Q75))? 0 : Q75) + parseFloat((typeof Q76==='undefined' || Q76==='' || Number.isNaN(Q76))? 0 : Q76) + parseFloat((typeof Q77==='undefined' || Q77==='' || Number.isNaN(Q77))? 0 : Q77) + parseFloat((typeof Q78==='undefined' || Q78==='' || Number.isNaN(Q78))? 0 : Q78) + parseFloat((typeof Q79==='undefined' || Q79==='' || Number.isNaN(Q79))? 0 : Q79)).toFixed())
    }, [Q53, Q54, Q55, Q56, Q57, Q58, Q59, Q60, Q61, Q62, Q63, Q64, Q65, Q66, Q67, Q68, Q69, Q70, Q71, Q72, Q73, Q74, Q75, Q76, Q77, Q78, Q79, setQ52])

    const [ButtonColor, setButtonColor] = useState('inactive')
    const [Balance, setBalance] = useState('0')

    const calculater = () => {
        if (((`${(parseFloat(Q26) - (parseFloat(Q27) + parseFloat(Q34) + parseFloat(Q48) + parseFloat(Q52)))}`) === 'NaN') || ((parseFloat(Q26) - (parseFloat(Q27) + parseFloat(Q34) + parseFloat(Q48) + parseFloat(Q52))) === 0)) {
            setButtonColor('green')
            setBalance('zero')
        }
        else if ((parseFloat(Q26) - (parseFloat(Q27) + parseFloat(Q34) + parseFloat(Q48) + parseFloat(Q52))) > 0) {
            setBalance('positive')
            setButtonColor('red')
        }
        else {
            setBalance('negative')
            setButtonColor('red')
        }
    }

    const history = useHistory()
    const data = {
                advertising_marketing:Q53,
                asset_purchase:Q54,
                bank_service_charge:Q55,
                bank_insurance:Q56,
                charitable_contribution:Q57,
                company_contribution_retirement_staff:Q58,
                continuing_education:Q59,
                entertainment:Q60,
                business_personal_property_tax:Q61,
                gift:Q62,
                health_insurance_staff:Q63,
                interest_expenses:Q64,
                loan_payment_balance_sheet:Q65,
                meals:Q66,
                merchant_service_fees:Q67,
                office_phone:Q68,
                office_rent:Q69,
                office_repair_maintenance:Q70,
                office_supplies:Q71,
                office_utilities:Q72,
                other_contract_expenses:Q73,
                postage_and_delivery:Q74,
                professional_fees:Q75,
                telephone:Q76,
                total_wages_from_payroll:Q77,
                workers_compensation_insurance:Q78,
                other_operating_expenses:Q79,
                expenses_write_here:expensesWriteHere,
                edited_quater:null,
                operating_expenses:Q52
            }

    const rollOut = () => {
        if (true) {
            // const data = {
            //     advertising_marketing:Q53,
            //     asset_purchase:Q54,
            //     bank_service_charge:Q55,
            //     bank_insurance:Q56,
            //     charitable_contribution:Q57,
            //     company_contribution_retirement_staff:Q58,
            //     continuing_education:Q59,
            //     entertainment:Q60,
            //     business_personal_property_tax:Q61,
            //     gift:Q62,
            //     health_insurance_staff:Q63,
            //     interest_expenses:Q64,
            //     loan_payment_balance_sheet:Q65,
            //     meals:Q66,
            //     merchant_service_fees:Q67,
            //     office_phone:Q68,
            //     office_rent:Q69,
            //     office_repair_maintenance:Q70,
            //     office_supplies:Q71,
            //     office_utilities:Q72,
            //     other_contract_expenses:Q73,
            //     postage_and_delivery:Q74,
            //     professional_fees:Q75,
            //     telephone:Q76,
            //     total_wages_from_payroll:Q77,
            //     workers_compensation_insurance:Q78,
            //     other_operating_expenses:Q79,
            //     expenses_write_here:expensesWriteHere,
            //     edited_quater:null,
            //     operating_expenses:Q52
            // }
            submitCall(Q52,data)
            // history.push("/")
        }
        else {
        }
    }

    const handleSave = () => {
        if (true) {
            saveCall(Q52,data)
        }
        else {
            console.log('Something wrong')
        }
    }

    const anotherYear = () => {
        setWorksheetYear('April,2021-May,2022');
        // submitCall()
        // history.push('/worksheet1')
    }

    return (
        <>
            <div className='worksheet_main'>
            <div className={'page_content'}>
                <div className='worksheet_form_container'>
                    <div className='worksheet_form_header'>
                         <div className='flex_image' >
                            <h4>Operating Expenses Worksheet</h4>
                            <a href="https://pat-api.profitfirsttools.com/static/video/operating-expenses-worksheet.mp4" target="_blank"><img alt='' className="video-icon" src={video_player} /> <i>Watch Tutorial</i></a>
                        </div>
                        <h3 className={`worksheet_form_header_h3`} >{mainData?.analyzing_report?.run_rate ? `${momentConvertFormat(mainData?.analyzing_report?.starting_month,'YYYY-MM-DD','MM/DD/YYYY')} - ${momentConvertFormat(mainData?.analyzing_report?.ending_month,'YYYY-MM-DD','MM/DD/YYYY')}` : mainData?.analyzing_report?.analysing_year}</h3>
                    </div>
                    <form className='worksheet_form' onSubmit={(e) => { e.preventDefault(); (Analyze === 'yes') ? setShowPopup(true) : rollOut(); console.log(Analyze) }}>
                        <div className='worksheet_table_container'>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                    <span className='worksheet_left worksheet_dark_left'>Operating Expenses</span>
                                </div>
                                <div className='worksheet_right_side'>
                                {/* <span className='worksheet_right worksheet_dark_right'>{Q52 === 'NaN' ? '0.00' : Q52}</span> */}
                                <NumberFormat className='worksheet_right worksheet_dark_right' value={Q52 === 'NaN' ? `${currency}0` : Q52} displayType={'text'}  thousandSeparator={true} prefix={currency} renderText={(value, props) => <div {...props}>{value}</div>}/>
                                    {/* <span className='worksheet_right'><input placeholder='0.00' value={Q53} onChange={(e) => setQ53(e.target.value)} /></span> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                     <span className='worksheet_left'>Advertising / Marketing</span>
                                </div>
                                <div className='worksheet_right_side'>
                                    <CustomInput value={Q53} formatedValue={Q53} unit={mainData?.client_information?.currency} changeValue={(val,val2)=>setQ53(val)}/>
                                   </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                    <span className='worksheet_left'>Asset Purchases, like Furniture, Vehicles, Equipment (from Balance Sheet)</span>
                                </div>
                                <div className='worksheet_right_side'>
                                    <CustomInput value={Q54} formatedValue={Q54} unit={mainData?.client_information?.currency} changeValue={(val,val2)=>setQ54(val)}/>
                                     </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Bank Service Charges</span>
                                </div>
                                <div className='worksheet_right_side'>
                                    <CustomInput value={Q55} formatedValue={Q55} unit={mainData?.client_information?.currency} changeValue={(val,val2)=>setQ55(val)}/>
                                 </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Business Insurance</span>
                                </div>
                                <div className='worksheet_right_side'>
                                    <CustomInput value={Q56} formatedValue={Q56} unit={mainData?.client_information?.currency} changeValue={(val,val2)=>setQ56(val)}/>
                                 </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Charitable Contributions</span>
                                </div>
                                <div className='worksheet_right_side'>
                                    <CustomInput value={Q57} formatedValue={Q57} unit={mainData?.client_information?.currency} changeValue={(val,val2)=>setQ57(val)}/>
                                  </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Company Contributions to Retirement – Staff</span>
                                </div>
                                <div className='worksheet_right_side'>
                                    <CustomInput value={Q58} formatedValue={Q58} unit={mainData?.client_information?.currency} changeValue={(val,val2)=>setQ58(val)}/>
                                  </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Continuing Education</span>
                                </div>
                                <div className='worksheet_right_side'>
                                    <CustomInput value={Q59} formatedValue={Q59} unit={mainData?.client_information?.currency} changeValue={(val,val2)=>setQ59(val)}/>
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Entertainment</span>
                                </div>
                                <div className='worksheet_right_side'>
                                    <CustomInput value={Q60} formatedValue={Q60} unit={crun} changeValue={(val,val2)=>setQ60(val)}/>
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Franchise / Business Personal Property Taxes (not Income Taxes)</span>
                                </div>
                                <div className='worksheet_right_side'>
                                    
                                <CustomInput value={Q61} formatedValue={Q61} unit={crun} changeValue={(val,val2)=>setQ61(val)}/>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q61} onChange={(e) => setQ61(e.target.value)} /> */}
                                  {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q61} placeholder="$0.00" onValueChange={(value) => setQ61(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Gifts</span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q62} formatedValue={Q62} unit={crun} changeValue={(val,val2)=>setQ62(val)}/>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q62} onChange={(e) => setQ62(e.target.value)} /> */}
                                  {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q62} placeholder="$0.00" onValueChange={(value) => setQ62(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Health Insurance - Staff</span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q63} formatedValue={Q63} unit={crun} changeValue={(val,val2)=>setQ63(val)}/>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q63} onChange={(e) => setQ63(e.target.value)} /> */}
                                  {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q63} placeholder="$0.00" onValueChange={(value) => setQ63(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Interest Expenses</span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q64} formatedValue={Q64} unit={crun} changeValue={(val,val2)=>setQ64(val)}/>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q64} onChange={(e) => setQ64(e.target.value)} /> */}
                                  {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q64} placeholder="$0.00" onValueChange={(value) => setQ64(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Loan Payments (from Balance Sheet)</span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q65} formatedValue={Q65} unit={crun} changeValue={(val,val2)=>setQ65(val)}/>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q65} onChange={(e) => setQ65(e.target.value)} /> */}
                                  {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q65} placeholder="$0.00" onValueChange={(value) => setQ65(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Meals</span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q66} formatedValue={Q66} unit={crun} changeValue={(val,val2)=>setQ66(val)}/>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q66} onChange={(e) => setQ66(e.target.value)} /> */}
                                  {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q66} placeholder="$0.00" onValueChange={(value) => setQ66(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Merchant Service (Credit Card) Fees</span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q67} formatedValue={Q67} unit={crun} changeValue={(val,val2)=>setQ67(val)}/>
                                 {/* <input className='worksheet_right' placeholder='0.00' value={Q67} onChange={(e) => setQ67(e.target.value)} /> */}
                                 {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q67} placeholder="$0.00" onValueChange={(value) => setQ67(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Office Phone</span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q68} formatedValue={Q68} unit={crun} changeValue={(val,val2)=>setQ68(val)}/>
                                    {/* <input className='worksheet_right' placeholder='0.00' value={Q68} onChange={(e) => setQ68(e.target.value)} /> */}
                                    {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q68} placeholder="$0.00" onValueChange={(value) => setQ68(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Office Rent</span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q69} formatedValue={Q69} unit={crun}  changeValue={(val,val2)=>setQ69(val)}/>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q69} onChange={(e) => setQ69(e.target.value)} /> */}
                                  {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q69} placeholder="$0.00" onValueChange={(value) => setQ69(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Office Repairs and Maintenance</span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q70} formatedValue={Q70} unit={crun} changeValue={(val,val2)=>setQ70(val)}/>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q70} onChange={(e) => setQ70(e.target.value)} /> */}
                                  {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q70} placeholder="$0.00" onValueChange={(value) => setQ70(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Office Supplies</span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q71} formatedValue={Q71} unit={crun} changeValue={(val,val2)=>setQ71(val)}/>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q71} onChange={(e) => setQ71(e.target.value)} /> */}
                                  {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q71} placeholder="$0.00" onValueChange={(value) => setQ71(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Office Utilities</span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q72} formatedValue={Q72} unit={crun} changeValue={(val,val2)=>setQ72(val)}/>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q72} onChange={(e) => setQ72(e.target.value)} /> */}
                                  {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q72} placeholder="$0.00" onValueChange={(value) => setQ72(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Other Contractor Expenses (not Materials and Subs)</span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q73} formatedValue={Q73} unit={crun} changeValue={(val,val2)=>setQ73(val)}/>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q73} onChange={(e) => setQ73(e.target.value)} /> */}
                                  {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q73} placeholder="$0.00" onValueChange={(value) => setQ73(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Postage and Delivery</span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q74} formatedValue={Q74} unit={crun} changeValue={(val,val2)=>setQ74(val)}/>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q74} onChange={(e) => setQ74(e.target.value)} /> */}
                                  {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q74} placeholder="$0.00" onValueChange={(value) => setQ74(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Professional Fees (Accounting, Legal, etc.)</span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q75} formatedValue={Q75} unit={crun} changeValue={(val,val2)=>setQ75(val)}/>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q75} onChange={(e) => setQ75(e.target.value)} /> */}
                                  {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q75} placeholder="$0.00" onValueChange={(value) => setQ75(value.floatValue)}/> */}
                                </div>
                            </div>
                            {/* <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Telephone</span>
                                </div>
                                <div className='worksheet_right_side'>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q76} onChange={(e) => setQ76(e.target.value)} /> }
                                  <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q76} placeholder="$0.00" onValueChange={(value) => setQ76(value.floatValue)}/>
                                </div>
                            </div> */}
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Total Wages from Payroll (Gross, Including Taxes) - Staff</span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q77} formatedValue={Q77} unit={crun} changeValue={(val,val2)=>setQ77(val)}/>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q77} onChange={(e) => setQ77(e.target.value)} /> */}
                                  {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q77} placeholder="$0.00" onValueChange={(value) => setQ77(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>Worker's Compensation Insurance</span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q78} formatedValue={Q78} unit={crun} changeValue={(val,val2)=>setQ78(val)}/>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q78} onChange={(e) => setQ78(e.target.value)} /> */}
                                  {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q78} placeholder="$0.00" onValueChange={(value) => setQ78(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <span className='worksheet_left'>
                                    <span className="spancol">Other Operating Expenses</span>
                                    <span className="spancol" style={{ paddingRight: '20px' }}>Note: Please list items included in this amount</span>
                                </span>
                                </div>
                                <div className='worksheet_right_side'>
                                <CustomInput value={Q79} formatedValue={Q79} unit={crun} changeValue={(val,val2)=>setQ79(val)}/>
                                  {/* <input className='worksheet_right' placeholder='0.00' value={Q79} onChange={(e) => setQ79(e.target.value)} /> */}
                                  {/* <NumberFormat className='worksheet_right' thousandSeparator={true} prefix={'$'} value={Q79} placeholder="$0.00" onValueChange={(value) => setQ79(value.floatValue)}/> */}
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                <input value={expensesWriteHere} onChange={(e)=>setExpensesWriteHere(e.target.value)} className='worksheet_left' placeholder='Write here'></input>
                                </div>
                                <div className='worksheet_right_side'>
                                    <span className='worksheet_right worksheet_last'>&nbsp;</span>
                                </div>
                            </div>
                            <div className='worksheet_table-row'>
                                <div className='worksheet_left_side'>
                                    <span className='worksheet_left worksheet_dark_left'>Operating Expenses Adjustment</span>
                                </div>
                                <div className='worksheet_right_side'>
                                    <NumberFormat className='worksheet_right worksheet_dark_right' value={mainData?.worksheet?.operating_expenses_adjustment === 'NaN' ? `${currency}0` : mainData?.worksheet?.operating_expenses_adjustment} displayType={'text'}  thousandSeparator={true} prefix={currency} renderText={(value, props) => <div {...props}>{value}</div>}/>
                                    {/* <span className='worksheet_right worksheet_dark_right'>{Q27 === 'NaN' ? '0.00' : Q27}</span> */}
                                </div>
                            </div>
                        </div>
                        {/* <div className='worksheet5_btn1'>
                            <button className='worksheet_active_btn' type='button' onClick={calculater}>Calculate</button>
                            <button className={`worksheet_inactive_btn ${ButtonColor === 'red' ? `worksheet_btn_red` : ButtonColor === 'green' ? `worksheet_btn_green` : `nothing`}`} type='button'>Balance Check</button>
                        </div>
                        <div className='worksheet5_btn2'>
                            <button className={`worksheet_inactive_btn ${Balance === 'positive' && `activate_worksheet_btn`}`} type='button'>Apply difference to operating expenses (See Video)</button>
                            <button className={`worksheet_inactive_btn ${Balance === 'negative' && `activate_worksheet_btn`}`} type='button'>Apply difference to profit (see video)</button>
                        </div>
                        <div className='worksheet_radio_container'>
                            <label>Would you like to analyze another year?</label>
                            <div>
                                <div><input onChange={(e) => setAnalyze(e.target.value)} className='worksheet_radio' type="radio" name="another_year" value='yes' required /><span>Yes</span></div>
                                <div><input onChange={(e) => setAnalyze(e.target.value)} style={{ marginLeft: "40px" }} className='worksheet_radio' type="radio" name="another_year" value='no' required /><span>No</span></div>
                            </div>
                        </div> */}
                        <div className='worksheet_footer'>
                            <button className='worksheet_previous_btn' onClick={backCall} >Previous</button>
                            <div className='worksheet_progress_bar' style={{ left: '0' }}><div className='worksheet_progress' style={{ width: "87.5%" }}></div></div>
                            <button className='worksheet_submit_btn' type='submit'>Save and continue</button>
                        </div>
                        <Autosave data={data} onSave={handleSave} />
                    </form>
                </div>
                <Footer />
            </div>
            </div>
        </>
    )
}

export default Worksheet5
